export const BALANCE_COLS = [
  { key: "ferie_balance", label: "Ferie", short: "Ferie", unit: "gg" },
  { key: "prev_ferie_balance", label: "Ferie anno precedente", short: "Ferie AP", unit: "gg" },
  { key: "rol_balance", label: "ROL", short: "ROL", unit: "h" },
  { key: "prev_rol_balance", label: "ROL anno precedente", short: "ROL AP", unit: "h" },
  { key: "exfestivita_balance", label: "Ex festività", short: "Ex fest.", unit: "h" },
  { key: "prev_exfestivita_balance", label: "Ex festività anno precedente", short: "Ex fest. AP", unit: "h" },
  { key: "studio_balance", label: "Permessi studio", short: "Studio", unit: "h" },
  { key: "overtime", label: "Straordinari", short: "Straord.", unit: "h" },
];

export const fmtNum = (v) =>
  Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export const fmtSigned = (v) => `${Number(v) > 0 ? "+" : ""}${fmtNum(v)}`;

export const fmtDateTime = (iso) => {
  try {
    return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso || ""; }
};

export const apiError = (e, fallback) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
};
